export const ROBOT_PART_REMOVE_CONFIRM_PREFIX = 'ROBOT_PART_REMOVE_CONFIRM';
export const ROBOT_PART_REMOVE_CONFIRM_REQUEST = `${ROBOT_PART_REMOVE_CONFIRM_PREFIX}_REQUEST`;
export const ROBOT_PART_REMOVE_CONFIRM_SUCCESS = `${ROBOT_PART_REMOVE_CONFIRM_PREFIX}_SUCCESS`;
export const ROBOT_PART_REMOVE_CONFIRM_ERROR = `${ROBOT_PART_REMOVE_CONFIRM_PREFIX}_ERROR`;
export const ROBOT_PART_REMOVE_CONFIRM_ERROR_MESSAGE = 'Error removing robot part';

export const removeRobotPartConfirmRequest = () => ({
  type: ROBOT_PART_REMOVE_CONFIRM_REQUEST,
});
